(function () {
  function applyOpenInNewTab(root) {
    root.querySelectorAll('.b2b-science-pubs__card-link[data-open-new-tab="true"]').forEach(function (link) {
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
    });
  }

  function normalizeSlug(value) {
    return (value || '').trim().toLowerCase();
  }

  function cardCategorySlugs(card) {
    var raw = card.getAttribute('data-pub-categories') || '';

    return raw
      .trim()
      .toLowerCase()
      .split(/\s+/)
      .filter(Boolean);
  }

  function cardMatchesFilter(card, slug) {
    if (normalizeSlug(slug) === 'all') return true;

    var wanted = normalizeSlug(slug);
    return cardCategorySlugs(card).indexOf(wanted) !== -1;
  }

  function initMobileDropdown(root, tabs, onSelect) {
    var dropdown = root.querySelector('[data-b2b-pub-filter-dropdown]');
    var trigger = dropdown && dropdown.querySelector('[data-b2b-pub-filter-trigger]');
    var label = dropdown && dropdown.querySelector('[data-b2b-pub-filter-label]');
    var menu = dropdown && dropdown.querySelector('[data-b2b-pub-filter-menu]');

    if (!dropdown || !trigger || !label || !menu || !tabs.length) return null;

    menu.innerHTML = '';

    tabs.forEach(function (tab) {
      var item = document.createElement('li');
      item.className = 'b2b-science-pubs__filter-dropdown-option';
      item.setAttribute('role', 'presentation');

      var option = document.createElement('button');
      option.type = 'button';
      option.className = 'b2b-science-pubs__filter-dropdown-option-btn';
      option.setAttribute('role', 'option');
      option.setAttribute('data-pub-filter-option', tab.getAttribute('data-pub-filter'));
      option.textContent = tab.textContent.trim();
      option.addEventListener('click', function () {
        onSelect(tab.getAttribute('data-pub-filter'));
        closeMenu();
      });

      item.appendChild(option);
      menu.appendChild(item);
    });

    function getActiveTab() {
      var tabList = root.querySelector('.b2b-science-pubs__filters');
      if (!tabList) return tabs[0];

      return (
        tabList.querySelector('[data-pub-filter][aria-selected="true"]') ||
        tabs[0]
      );
    }

    function syncMenuSelection() {
      var active = getActiveTab();
      var activeSlug = active ? normalizeSlug(active.getAttribute('data-pub-filter')) : '';

      menu.querySelectorAll('[data-pub-filter-option]').forEach(function (option) {
        var isActive = normalizeSlug(option.getAttribute('data-pub-filter-option')) === activeSlug;
        option.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      if (active) {
        label.textContent = active.textContent.trim();
      }
    }

    function openMenu() {
      dropdown.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      menu.hidden = false;
      syncMenuSelection();
    }

    function closeMenu() {
      dropdown.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      menu.hidden = true;
    }

    trigger.addEventListener('click', function () {
      if (dropdown.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    document.addEventListener('click', function (event) {
      if (!dropdown.classList.contains('is-open')) return;
      if (dropdown.contains(event.target)) return;
      closeMenu();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeMenu();
    });

    return {
      sync: syncMenuSelection,
      close: closeMenu,
    };
  }

  function initPublications(root) {
    applyOpenInNewTab(root);

    var tabList = root.querySelector('.b2b-science-pubs__filters');
    var tabs = tabList ? tabList.querySelectorAll('[data-pub-filter]') : [];
    var cards = root.querySelectorAll('.b2b-science-pubs__card');
    var empty = root.querySelector('[data-pub-empty]');
    var cta = root.querySelector('.b2b-science-pubs__cta');

    if (!tabs.length) return;

    function isAllPublicationsFilter(slug) {
      var wanted = normalizeSlug(slug);
      return wanted === 'all' || wanted === 'classification-all-publications';
    }

    var mobileDropdown = null;

    function setActive(slug) {
      var visible = 0;

      var wanted = normalizeSlug(slug);

      tabs.forEach(function (tab) {
        var isActive = normalizeSlug(tab.getAttribute('data-pub-filter')) === wanted;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      cards.forEach(function (card) {
        var show = cardMatchesFilter(card, slug);
        card.hidden = !show;
        if (show) visible += 1;
      });

      if (empty) {
        empty.hidden = visible > 0;
      }

      if (cta) {
        cta.hidden = isAllPublicationsFilter(slug);
      }

      if (mobileDropdown) {
        mobileDropdown.sync();
      }
    }

    mobileDropdown = initMobileDropdown(root, tabs, setActive);

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setActive(tab.getAttribute('data-pub-filter'));
        if (mobileDropdown) mobileDropdown.close();
      });
    });

    var initial = tabList
      ? tabList.querySelector('[data-pub-filter][aria-selected="true"]')
      : null;
    setActive(initial ? initial.getAttribute('data-pub-filter') : tabs[0].getAttribute('data-pub-filter'));
  }

  function boot() {
    document.querySelectorAll('[data-b2b-science-pubs]').forEach(initPublications);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
